"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffsSeatsCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
const tariffGroupMapper_1 = require("../../../../TariffsTable/tariffGroupMapper");
const FlightSeatCount_1 = require("../../FlightSeatCount");
require("./index.scss");
const className = 'tariffs-seats-cell';
const TariffsSeatsCell = (props) => {
    const { seats = [], tariffGroupList = [], isShowTotal = true, allowedNegative, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const total = seats.reduce((acc, seatsConfig) => acc + seatsConfig.seatsForSale, 0);
    return (react_1.default.createElement("span", { className: className },
        isShowTotal && (react_1.default.createElement("span", { className: `${className}__total` }, total)),
        react_1.default.createElement("span", { className: `${className}__tariffs` }, tariffGroupList.map((tariffGroup, index) => {
            var _a, _b;
            const tariffSeats = seats.filter(x => { var _a; return ((_a = x.tariffGroup) === null || _a === void 0 ? void 0 : _a.id) === tariffGroup.id; }).pop();
            const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id);
            const classNames = (0, classFunctions_1.getClassNames)(`${className}__tariff`, [
                `color-${tariffCode}`,
            ]);
            return (react_1.default.createElement("span", { key: index, title: (_a = tariffGroup.name[locale]) !== null && _a !== void 0 ? _a : '', className: classNames },
                react_1.default.createElement(FlightSeatCount_1.FlightSeatCount, { value: (_b = tariffSeats === null || tariffSeats === void 0 ? void 0 : tariffSeats.seatsForSale) !== null && _b !== void 0 ? _b : 0, allowedNegative: allowedNegative })));
        }))));
};
exports.TariffsSeatsCell = TariffsSeatsCell;
//# sourceMappingURL=index.js.map